<template>
  <div
    v-if="$viewport.isMd || $parent.$options.name !== 'c-collapse-group'"
    :id="tabPanelId"
    :aria-labelledby="tabId"
    :class="b({ isActive, padding: isActive && padding })"
    tabindex="0"
    role="tabpanel"
  >
    <slot></slot>
  </div>
  <c-collapse
    v-else
    :title="name"
    :active="isActive"
    :padding="padding"
    :slug="slug"
  >
    <slot></slot>
  </c-collapse>
</template>

<script>
  import { inject } from 'vue';
  import cCollapse from '@/components/c-collapse.vue';
  import useUuid from '@/compositions/uuid.js';
  import propScale from '@/helpers/prop.scale.js';

  /**
   * Renders a tab element.
   */
  export default {
    name: 'c-tab-panel',

    components: { cCollapse },
    // mixins: [],

    props: {
      /**
       * The name of the tab element.
       */
      name: {
        type: String,
        required: true,
      },

      /**
       * The slug of the tab element.
       */
      slug: {
        type: String,
        default: '',
      },

      /**
       * Initial active state.
       */
      selected: {
        type: Boolean,
        default: false,
      },

      /**
       * Defines the padding of the inner content.
       */
      padding: propScale(500, [0, 500]),
    },

    emits: ['change'],

    setup() {
      const tabsProvider = inject('TabsProvider');

      return {
        ...useUuid(),
        tabsProvider,
      };
    },

    // data() {
    //   return {
    //   };
    // },

    computed: {
      /**
       * A unique id for the tab.
       * Needed for proper aria labeling.
       *
       * @returns {String}
       */
      tabId() {
        return `tab-${this.uuid}`;
      },

      /**
       * A unique id for the tab panel.
       * Needed for proper aria labeling.
       *
       * @returns {String}
       */
      tabPanelId() {
        return `tabpanel-${this.uuid}`;
      },

      /**
       * Checks if the tab is active or not.
       *
       * @returns {Boolean}
       */
      isActive() {
        if (this.tabsProvider.activeTabId) {
          return this.tabsProvider.activeTabId === this.tabId;
        }

        return this.selected;
      },
    },
    watch: {
      isActive(isActive) {
        if (isActive) {
          this.$emit('change');
        }
      },
    },

    // beforeCreate() {},
    // created() {},
    beforeMount() {
      const { tabId, isActive, tabPanelId, name, slug } = this;

      if (!this.tabsProvider.tabs.find((tab) => tab.tabId === tabId)) {
        this.tabsProvider.tabs.push({
          tabId,
          isActive,
          tabPanelId,
          name,
          slug,
        });
      }
    },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  // @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-tab-panel {
    $this: &;

    max-height: 0;
    overflow: hidden;
    opacity: 0;
    outline: 0;
    transition:
      opacity variables.$transition-duration--500 ease-in-out,
      max-height variables.$transition-duration--500 ease-in-out;

    &--padding-500 {
      padding: functions.rem(variables.$spacing--50 0 0);
    }

    &--is-active {
      max-height: none;
      overflow: visible;
      opacity: 1;
    }

    .c-slider-1,
    .c-slider-2,
    .c-cms-image-gallery {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>
